import jsonURL from 'json-url';

const codec = jsonURL('lzw');

export function compressData<T extends object>(data: T) {
  return codec.compress(data);
}
